import React, { Component } from "react";

class GetFullYear extends React.Component {
  render() {
    return <div>{new Date().getFullYear()}</div>;
  }
}
export default GetFullYear;
